/* eslint-disable camelcase */
import Vue from 'vue'
import App from '@/App'
import router from '@/router'
import components from '@/components'
import pipe from '@/pipe'
import axios from 'axios'
import vuetify from '@/plugins/vuetify'
import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import '@/assets/css/bootstrap.min.css'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import 'es6-promise/auto'

Vue.config.productionTip = false

Vue.use(VueSweetalert2)
Vue.use(PerfectScrollbar)

Vue.prototype.$axios = axios

new Vue({
  components,
  pipe,
  vuetify,
  router,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js